module.exports = __webpack_public_path__ + "img/woman-profile.59928857.svg";